import { useContext } from 'react'
import { postRequest, putRequest } from '../../../../services/base'
import Button from '../../../common/Button'
import InputText from '../../../common/InputText'
import {
  HarnessListContext,
  UPDATE_CHANGE_HARNESS_DATA,
} from '../context/context'
import { NavContext } from '../../../../context/global_context'
import { useParams } from 'react-router-dom'

const HarnessForm = (props) => {
  const { vehicle } = useParams()
  const [state, dispatch] = useContext(HarnessListContext)
  const [value, navDispatch] = useContext(NavContext)

  const saveHarness = async (e) => {
    let formData = new FormData(e.target)
    if (state?.selectedObject?.id) {
      let res = await putRequest(
        `/api/harnesses/${state?.selectedObject?.id}/?vehicle=${vehicle}`,
        formData
      )
      dispatch({
        type: UPDATE_CHANGE_HARNESS_DATA,
        data: { ...res, index: state?.selectedObject?.index },
      })
    } else {
      let res = await postRequest(
        `/api/harnesses/?vehicle=${vehicle}`,
        formData
      )
    }
    navDispatch({
      type: 'notification',
      data: {
        notification_type: 'success',
        msg: `Data saved successfully`,
      },
    })
    props.onSave()
  }

  return (
    <div className="">
      <form
        onSubmit={(e) => {
          e.preventDefault()
          saveHarness(e)
        }}
      >
        <div className="flex">
          <div className="w-1/2">
            <InputText
              name="harness_id"
              type="text"
              label="Harness Id"
              value={state?.selectedObject?.harness_id}
            />
          </div>
          <div className="w-1/2">
            <InputText
              name="part_number"
              type="text"
              label="Part Number"
              value={state?.selectedObject?.part_number}
            />
          </div>
        </div>
        <div className="flex">
          <div className="w-1/2">
            <InputText
              name="base_part_number"
              type="text"
              label="Harness Type"
              value={state?.selectedObject?.base_part_number}
              isRequired={false}
            />
          </div>
          <div className="w-1/2">
            <InputText
              name="abbreviation"
              type="text"
              label="abbreviation"
              value={state?.selectedObject?.abbreviation}
              isRequired={false}
            />
          </div>
        </div>
        <div className="flex">
          <div className="w-1/2">
            <InputText
              name="description"
              type="text"
              label="Description"
              value={state?.selectedObject?.description}
              isRequired={false}
            />
          </div>
        </div>
        <div className="flex justify-end">
          <div className="w-1/4 mr-2">
            <Button
              type="submit"
              className={`cursor-pointer btn my-4 w-full justify-end`}
              onClick={(e) => {}}
              value={'text'}
              text={'Save'}
            />
          </div>
        </div>
      </form>
    </div>
  )
}

export default HarnessForm
